<template>
  <el-button
    v-bind="$attrs"
    :size="size"
    :title="title"
    class="bdc-column-filter-btn"
    v-on="$listeners"
  >
    <svg-icon icon-class="bdc-btn-list" class="bdc-column-filter-btn__list" />
    <svg-icon icon-class="bdc-btn-arrow-single" class="bdc-column-filter-btn__arrow" />
  </el-button>
</template>

<script>
export default {
  name: 'BdcColumnFilterButton',
  inheritAttrs: false,
  props: {
    size: {
      type: String,
      default: 'small'
    },
    title: {
      type: String,
      default: '筛选列'
    }
  }
}
</script>
